
<script setup lang="ts">
import { useTocStore } from '~/store/tocStore';
import EnergyInfoCard from '@/client/pages/design-toc/component/energy-info-card.vue';
import BasicInfoCard from '@/client/pages/design-toc/component/basic-info-card.vue';
import LinkageInfoCard from '@/client/pages/design-toc/component/linkage-info-card.vue';
import TotalProdCard from '@/client/pages/design-toc/component/total-prod-card.vue';
import ProdChart from '@/client/pages/design-toc/component/prod-chart.vue';
import { useCommonCodeStore } from '~/store/commonCodeStore';

import dashboardJson from '@/assets/data/default.json';
import Dashboard from '../component/dashboard/dashboard.vue';

const route = useRoute();
const router = useRouter();

const tocStore = useTocStore();
const commonCodeStore = useCommonCodeStore();

const dashboardData = computed(() => dashboardJson['dashboard']);

commonCodeStore.init();


const prodDateType    = ref(0);
	/** 발전량 추이     */  const prodRes     = ref(await tocStore.tocDashboardProdData('', ''));   
	/** 이벤트 현황 RTU */  const eventRTURes    = ref(await tocStore.tocDashboarEventData('rtu') ?? []);
	/** 이벤트 현황 RTU */  const eventEquipRes    = ref(await tocStore.tocDashboarEventData('equip') ?? []);
	// /** 이벤트 현황 RTU */  const eventEquipRes    = ref([]);
  // /** 장애 추이       */  const faultRes    = ref(await tocStore.tocDashboardfaultData('', '', faultDateType.value)); 
	/** 발전량 추이     */  const trendRes    = ref(await tocStore.tocDashboardTrendData('', '', prodDateType.value)); 

const engSourceInfoList = computed(() => prodRes.value.prodByEngSources ?? []);

</script>

<template>
  <NuxtPage v-if="route.fullPath !== '/toc/dashboard/default'"/> 

  <div v-else class="dashboard row h-100">
    <Dashboard :widgets="dashboardData.widgets" :page-type="'dashboard'" :grid-system="dashboardData.gridSystem"></Dashboard>
  </div>
</template>

<style scoped lang="scss">
@import "@/assets/styles/design-toc/total-prod-card.scss";

</style>

<!-- <script setup lang="ts">
import { useTocStore } from '~/store/tocStore';
import EnergyInfoCard from '@/client/pages/design-toc/component/energy-info-card.vue';
import BasicInfoCard from '@/client/pages/design-toc/component/basic-info-card.vue';
import LinkageInfoCard from '@/client/pages/design-toc/component/linkage-info-card.vue';
import TotalProdCard from '@/client/pages/design-toc/component/total-prod-card.vue';
import ProdChart from '@/client/pages/design-toc/component/prod-chart.vue';
import { useCommonCodeStore } from '~/store/commonCodeStore';

const route = useRoute();
const router = useRouter();

const tocStore = useTocStore();
const commonCodeStore = useCommonCodeStore();


console.log(route);

commonCodeStore.init();


const prodDateType    = ref(0);
	/** 발전량 추이     */  const prodRes     = ref(await tocStore.tocDashboardProdData('', ''));   
	/** 이벤트 현황 RTU */  const eventRTURes    = ref(await tocStore.tocDashboarEventData('rtu') ?? []);
	/** 이벤트 현황 RTU */  const eventEquipRes    = ref(await tocStore.tocDashboarEventData('equip') ?? []);
	// /** 이벤트 현황 RTU */  const eventEquipRes    = ref([]);
  // /** 장애 추이       */  const faultRes    = ref(await tocStore.tocDashboardfaultData('', '', faultDateType.value)); 
	/** 발전량 추이     */  const trendRes    = ref(await tocStore.tocDashboardTrendData('', '', prodDateType.value)); 

const engSourceInfoList = computed(() => prodRes.value.prodByEngSources ?? []);

</script>

<template>
  <NuxtPage v-if="route.fullPath !== '/design-toc/dashboard'"/> 

  <div v-else class="dashboard row h-100">
    <div class="row col-6 h-100">
      <div class="col-6 p-1">
        <LinkageInfoCard :type="'dashboard'"></LinkageInfoCard>
      </div>
      <div class="col-6 p-1">
        <BasicInfoCard
        :total-count="prodRes.operEquipCount"
        :equip-status="prodRes.totalOperEquipStatus"
      >
      </BasicInfoCard>
      </div>
   
      <div class="col-6 p-1 h-23"  v-for="(engData,i) in engSourceInfoList">
        <EnergyInfoCard 
          :engData="engData"
        ></EnergyInfoCard>
      </div>
     
    </div>
    <div class="row col-3 h-100">
      <div class="col-12 p-1 h-25">
        <TotalProdCard
          :background-color="'linear-gradient(164deg, #2E85EB 2.14%, #1565C4 97.96%)'"
        >
          <template v-slot:title>
            전기 에너지
          </template>
          <template  v-slot:head-content>
            <div class="d-flex">
              <div class="head-content-wrapper">
                <span>금일 발전량</span>
                <span>90.6</span>
              </div>
              <span class="head-content-unit">MWh</span>
            </div>
          </template>
          <template v-slot:content>
            <div class="d-flex content-area">
              <div class="in-content-wrapper">
                <span>금월 발전량</span>
                <span>2,131.5</span>
              </div>
              <span class="in-content-unit">MWh</span>
            </div>
            <div class="d-flex content-area">
              <div class="in-content-wrapper">
                <span>금년 발전량</span>
                <span>13,180.5</span>
              </div>
              <span class="in-content-unit">MWh</span>
            </div>
            <div class="d-flex content-area">
              <div class="in-content-wrapper">
                <span>금일 CO₂저감량</span>
                <span>10.5</span>
              </div>
              <span class="in-content-unit">tCO₂eq</span>
            </div>
            <div class="d-flex content-area">
              <div class="in-content-wrapper">
                <span>누적 CO₂저감량</span>
                <span>3,120.5</span>
              </div>
              <span class="in-content-unit">tCO₂eq</span>
            </div>
          </template>
        </TotalProdCard>
      </div>
      <div class="col-12 p-1 h-25">
        <ProdChart
          :title="'금일 발전량'"
          :data="[1, 2, 3, 4, 5, 6, 7, 8, 9]"
          :categories="['0','1','2','3','4','5','6','7','8']"
          :series-key="'abc'"
          :colors="['#93B5FF']"
          :gradient-color="['#78A2E2']"
        ></ProdChart>
      </div>
      <div class="col-12 p-1 h-25">
        <ProdChart
          :title="'금월 발전량'"
          :data="[1, 2, 3, 4, 5, 6, 7, 8, 9]"
          :categories="['0','1','2','3','4','5','6','7','8']"
          :series-key="'abc'"
          :colors="['#93B5FF']"
          :gradient-color="['#78A2E2']"
        ></ProdChart>
      </div>
      <div class="col-12 p-1 h-25">
        <ProdChart
          :title="'금년 발전량'"
          :data="[1, 2, 3, 4, 5, 6, 7, 8, 9]"
          :categories="['0','1','2','3','4','5','6','7','8']"
          :series-key="'abc'"
          :colors="['#93B5FF']"
          :gradient-color="['#78A2E2']"
        ></ProdChart>
      </div>
  
    </div>
    <div class="row col-3 h-100">
      <div class="col-12 p-1 h-25">
        <TotalProdCard
          :background-color="'linear-gradient(164deg, #F27121 2.14%, #FF5E23 97.96%)'"
        >
          <template v-slot:title>
            열 에너지
          </template>
          <template  v-slot:head-content>
            <div class="d-flex">
              <div class="head-content-wrapper">
                <span>금일 발전량</span>
                <span>90.6</span>
              </div>
              <span class="head-content-unit">MWh</span>
            </div>
          </template>
          <template v-slot:content>
            <div class="d-flex content-area">
              <div class="in-content-wrapper">
                <span>금월 발전량</span>
                <span>2,131.5</span>
              </div>
              <span class="in-content-unit">MWh</span>
            </div>
            <div class="d-flex content-area">
              <div class="in-content-wrapper">
                <span>금년 발전량</span>
                <span>13,180.5</span>
              </div>
              <span class="in-content-unit">MWh</span>
            </div>
            <div class="d-flex content-area">
              <div class="in-content-wrapper">
                <span>금일 CO₂저감량</span>
                <span>10.5</span>
              </div>
              <span class="in-content-unit">tCO₂eq</span>
            </div>
            <div class="d-flex content-area">
              <div class="in-content-wrapper">
                <span>누적 CO₂저감량</span>
                <span>3,120.5</span>
              </div>
              <span class="in-content-unit">tCO₂eq</span>
            </div>
          </template>
        </TotalProdCard>
      </div>
      <div class="col-12 p-1 h-25">
        <ProdChart
          :title="'금일 발전량'"
          :data="[1, 2, 3, 4, 5, 6, 7, 8, 9]"
          :categories="['0','1','2','3','4','5','6','7','8']"
          :series-key="'abc'"
          :colors="['#FFBC93']"
          :gradient-color="['#E2AD78']"
        ></ProdChart>
      </div>
      <div class="col-12 p-1 h-25">
        <ProdChart
          :title="'금월 발전량'"
          :data="[1, 2, 3, 4, 5, 6, 7, 8, 9]"
          :categories="['0','1','2','3','4','5','6','7','8']"
          :series-key="'abc'"
          :colors="['#FFBC93']"
          :gradient-color="['#E2AD78']"
        ></ProdChart>
      </div>
      <div class="col-12 p-1 h-25">
        <ProdChart
          :title="'금년 발전량'"
          :data="[1, 2, 3, 4, 5, 6, 7, 8, 9]"
          :categories="['0','1','2','3','4','5','6','7','8']"
          :series-key="'abc'"
          :colors="['#FFBC93']"
          :gradient-color="['#E2AD78']"
        ></ProdChart>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
@import "@/assets/styles/design-toc/total-prod-card.scss";

</style> -->